import { Link } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";
import { CONTACT } from "@/data/content";

export function SofiHeader() {
  return (
    <header data-testid="sofi-header"
      className="sticky top-0 z-40 w-full border-b border-white/10 bg-[#070707]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
        <Link to="/" data-testid="sofi-header-logo" className="flex items-center gap-2.5">
          <img src="/sofi-avatar.png" alt="Sofi"
            className="h-9 w-9 rounded-full object-cover ring-2 ring-[#C73D3A]/50" />
          <div className="leading-tight">
            <div className="font-heading text-base font-bold tracking-tight">ADT · Софі</div>
            <div className="text-[10px] tracking-[0.2em] text-white/45">AI-РАДНИК З АВТО</div>
          </div>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/" data-testid="sofi-header-home"
            className="hidden rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-white/70 transition-colors hover:bg-white/5 hover:text-white sm:inline-flex">
            На головну
          </Link>
          <a href={`tel:${CONTACT.phoneRaw}`} data-testid="sofi-header-phone"
            className="inline-flex items-center gap-2 rounded-full bg-[#C73D3A] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#B12A2A]">
            <Phone className="h-4 w-4" /> <span className="hidden sm:inline">{CONTACT.phoneDisplay}</span>
            <span className="sm:hidden">Дзвінок</span>
          </a>
        </div>
      </div>
    </header>
  );
}
